var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileOptionSelector',{attrs:{"model":'smoking',"nextRoute":function () { return 'ReligionPage'; }}})}
var staticRenderFns = []

export { render, staticRenderFns }